import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button, Divider } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../../helpers/BreadcrumbsHelper';
import { SelectComponentV2 } from '../../components/SelectComponentV2';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import InputAdornment from '@material-ui/core/InputAdornment';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import { AppTheme } from '../../styles/AppTheme';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../../AppConfig';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { adminData } from '../../data/AdminData.js'
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { AppHelper } from '../../helpers/AppHelper';
import { DateRangePicker } from './DateRangePicker';
import { MultiCamPicker } from './MultiCamPicker'
import { EventFilter } from './EventFilter'
import Tooltip from '@material-ui/core/Tooltip';

export class EventRefreshController extends Component {
  constructor(props) {
    super(props);
    this.refreshValue = Controller.get().userMgr().getSettings()
    this.state = {
      autoUpdate: this.getInitRefreshVal()
    }
    if (AppConfig.autoUpdateEvent) {
      this.props.eventRefreshHandler(AppConfig.autoUpdateEvent)
    }
  }

  getInitRefreshVal = () => {
    if (this.refreshValue &&
      this.refreshValue.userSettings &&
      this.refreshValue.userSettings.eventRefresh) {
      return (this.refreshValue.userSettings.eventRefresh === 'ON' ? true : false)
    } else {
      return true
    }
  }

  onAutoUpdateChange = (event) => {
    let refreshValue = null
    if (event.target.checked) {
      refreshValue = 'ON'
    } else {
      refreshValue = 'OFF'
    }
    this.setState({ autoUpdate: event.target.checked }, () => Controller.get().userMgr().setUserSettings({ eventRefresh: refreshValue }))
    this.props.eventRefreshHandler(event.target.checked)
  }

  render() {
    return (
      <Tooltip title={'EVENT AUTO REFRESH'}>
        <div
          className={css(CommonStyles.headerMemberAddContainer, Styles.headerMemberAddContainerSecond)} >
          <p className={css(Styles.switchControlLabel)}> Event</p>
          <FormControlLabel
            color='secondary'
            className={css(Styles.formControlLabelContainer)}
            control={
              <Switch
                classes={{
                  track: this.state.autoUpdate && css(Styles.switchControlLabeltrack),
                  checked: css(Styles.switchControlLabelChecked),
                  thumb: css(Styles.switchControlLabelThumb),
                }}
                className={css(Styles.formControlSwitch)}
                checked={this.state.autoUpdate}
                onChange={this.onAutoUpdateChange}
              />
            }
          />
          {/*<p className={css(Styles.switchControlLabel)}>ON</p>*/}
        </div>
      </Tooltip>
    )
  }

}



// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventRefreshController.js